import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Variables from '../variables';

let snackBarRef = null

const saveSnackbarRef = (ref) => {
  snackBarRef = ref
}

const showSnackBar = ({ message, vertical, horizontal, severity, style }) => {
  snackBarRef?.setState({
    open: true,
    message: message || "success",
    vertical: vertical || 'top',
    horizontal: horizontal || 'center',
    severity: severity || "success",
    style
  })
}

const showMessage = (status, content) => {
  if (status == "success") {
    message.success(content)
  }
  if (status == "warning") {
    message.warning(content)
  }
  if (status == "error") {
    message.error(content)
  }

}

const isSubscriptionError = (err) => err?.response?.status === 403;

function camelCaseToTitle(text) {
  var result = text.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult
}

function checkUndefinedAndNull(value) {
  if (!value) return '-'
  else {
    return value
  }

}

const numWithCommas = num =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const AccountingFormat = (amount, currency = "") => {
  if (amount < 0)
    return `${currency}(${numWithCommas(
      Number(Math.abs(amount))
        .toFixed(2)
        .replace("-", "")
    )})`;
  else
    return `${currency}${numWithCommas(
      Number(amount)
        .toFixed(2)
        .replace("-", "")
    )}`;
};


const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();

    return (
      <Component
        navigate={navigate}
        {...props}
      />
    );
  };

  return Wrapper;
};
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

const currentDate = () => {
  return moment().format(Variables.dateFormat);
}

const GUARDSCONNECT_HOST_SEGMENT = 'guardsconnect';

const getBrandLogoUrl = (branding) => {
  const logo = branding?.logo;

  if (Array.isArray(logo)) {
    return logo?.[0]?.url || null;
  }

  if (logo && typeof logo === 'object') {
    return logo?.url || null;
  }

  if (typeof logo === 'string') {
    return logo;
  }

  return null;
};

const getBaseHostname = (hostname = window.location.hostname) => {
  const parts = hostname?.split('.').filter(Boolean) || [];

  if (!parts.length) return hostname;

  if (parts[parts.length - 1] === 'localhost') {
    return 'localhost';
  }

  const guardsConnectIndex = parts.findIndex(
    (part) => part?.toLowerCase() === GUARDSCONNECT_HOST_SEGMENT,
  );

  if (guardsConnectIndex >= 0) {
    return parts.slice(guardsConnectIndex).join('.');
  }

  return hostname;
};

const getPublicHostname = (hostname = window.location.hostname) => {
  return `app.${getBaseHostname(hostname)}`;
};

const getCompanyUrlFromHostname = (hostname = window.location.hostname) => {
  const baseHostname = getBaseHostname(hostname);

  if (
    !hostname ||
    hostname === baseHostname ||
    !hostname.endsWith(`.${baseHostname}`)
  ) {
    return null;
  }

  const companyUrl =
    hostname.slice(0, -(baseHostname.length + 1)).split('.')[0] || null;

  return companyUrl === 'app' ? null : companyUrl;
};

const addPortToHostname = (hostname, port) => {
  return port ? `${hostname}:${port}` : hostname;
};

const getPublicOnboardingUrl = (locationLike = window.location) => {
  const publicHostname = getPublicHostname(locationLike?.hostname);

  return `${locationLike?.protocol}//${addPortToHostname(
    publicHostname,
    locationLike?.port,
  )}/onboard-company`;
};

const getTenantLoginUrl = (companyUrl, locationLike = window.location) => {
  if (!companyUrl) {
    return getPublicOnboardingUrl(locationLike);
  }

  const baseHostname = getBaseHostname(locationLike?.hostname);

  return `${locationLike?.protocol}//${addPortToHostname(
    `${companyUrl}.${baseHostname}`,
    locationLike?.port,
  )}/login`;
};

const scrollPartially = (scrollContainerRef) => {
  if (!scrollContainerRef.current) return;

  const container = scrollContainerRef.current;
  const scrollableHeight = container.scrollHeight - container.clientHeight;

  // Example: 20% from bottom
  const targetScroll = scrollableHeight * 0.2;

  container.scrollTo({
    top: scrollableHeight - targetScroll,
    behavior: 'smooth'
  });
};

export default {
  snackBarRef,
  withRouter,
  saveSnackbarRef,
  showSnackBar,
  emailRegex,
  checkUndefinedAndNull,
  camelCaseToTitle,
  AccountingFormat,
  showMessage,
  isSubscriptionError,
  currentDate,
  scrollPartially,
  getBrandLogoUrl,
  getPublicHostname,
  getCompanyUrlFromHostname,
  getPublicOnboardingUrl,
  getTenantLoginUrl,
}
